import React from "react";
import {
  getPublicOrdersData,
} from "../../Redux/Actions/PublicOrders";
import { connect } from "react-redux";
import { store } from "../../Redux/Store/Store";
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import Checkbox from "@mui/material/Checkbox";

class PublicOrders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          title: "Wybrane",
          field: "selected",
          render: (rowdata) => (
            <Checkbox
              checked={this.isSelected(rowdata)}
              onChange={(e) => this.onSelectChange(e, rowdata)}
              disabled={this.isDisabled(rowdata)}
            />
          ),
          sorting: false,
          filtering: false,
          cellStyle: { textAlign: "center" },
          width: 50,
        },
        {
          title: "Numer ogłoszenia o zamówieniu",
          field: "announcementNumber",
          width: 500,
          cellStyle: { wordBreak: "break-all" }
        },
        { 
          title: "Nazwa zamówienia",
          field: "announcementName",
          width: 500,
          cellStyle: { wordBreak: "break-all" }
        },
      ],
      pageSize: 10,
      pageNumber: 0,
      orderById: 1,
      orderDirection: "asc",
      selectedOrders: [],
    };
  }

  componentDidMount() {
    const { fetchData } = this.props;
    fetchData(this.props.projectId, this.state.pageSize, this.state.pageNumber);
  }

  onSelectChange = (e, order) => {
    const selected = e.target.checked;

    if (selected) {
      const itemOnList = this.state.selectedOrders.find(
        (x) => x.announcementNumber === order.announcementNumber
      );

      if (!itemOnList) {
        this.setState({
          ...this.state,
          selectedOrders: [...this.state.selectedOrders, order],
        });
      }
    } else {
      this.setState({
        ...this.state,
        selectedOrders: this.state.selectedOrders.filter(
          (x) => x.announcementNumber !== order.announcementNumber
        ),
      });
    }
  };

  isSelected = (item) => {
    const foundItem = this.state.selectedOrders.find(
      (x) => x.announcementNumber === item.announcementNumber
    );

    const alreadyPicked = this.props.pickedOrders.find(
      (x) => x.announcementNumber === item.announcementNumber
    );

    return foundItem !== undefined || alreadyPicked !== undefined;
  };

  isDisabled = (item) => {
    const alreadyPicked = this.props.pickedOrders.find(
      (x) => x.announcementNumber === item.announcementNumber
    );

    return alreadyPicked !== undefined;
  }

  handleFilterChange = (filter) => {
    const keyValuePairs = filter.map(f => Object.values(f));

    const filters = keyValuePairs
      .filter(([property, value]) => property && value !== undefined)
      .map(([property, value]) => ({
        property: property.replace('announcement', 'annoucement'),
        value,
        condition: "Contains",
      }));
      
    const { fetchData } = this.props;
    fetchData(
      this.props.projectId,
      this.state.pageSize,
      this.state.pageNumber,
      filters,
      0
    );
  };

  render() {
    const loadedData = this.state.loadedData
      ? this.state.loadedData
      : store.getState().publicOrders;

    let table;

    if (!loadedData.isLoading) {
      table = (
        <TableCustomLazyLoading
          initialPage={0}
          verticalAlign="baseline"
          columns={this.state.columns}
          data={loadedData.orders}
          orderBy={this.state.orderById}
          orderDirection={this.state.orderDirection}
          count={loadedData.count}
          page={this.state.pageNumber}
          pageSize={this.state.pageSize}
          onChangePage={(page, size) => {
            this.setState({ ...this.state, pageSize: size, pageNumber: page });
            const { fetchData } = this.props;
            fetchData(this.props.projectId, size, page);
          }}
          onFilterChange={this.handleFilterChange}
          onOrderChange={(column, order) => {
            this.setState({...this.state, orderById: column, orderDirection: order});

            const { fetchData } = this.props;

            fetchData(this.props.projectId, this.state.pageSize, this.state.pageNumber, [], {index: column, direction: order});
          }}
          onChangeRowsPerPage={(pageSize) => {
            this.setState({ ...this.state, pageSize: pageSize });
            const { fetchData } = this.props;

            fetchData(this.props.projectId, pageSize, this.state.pageNumber);
          }}
        />
      );
    }

    return (
      <div>
        {table}
        <div style={{ float: "right", marginTop: 15 }}>
          <button
            className="btn save-btn"
            disabled={this.state.selectedOrders.length === 0}
            onClick={() => {
              this.props.onPick(this.state.selectedOrders);
            }}
          >
            WYBIERZ
          </button>
          <button
            className="btn cancel-btn"
            onClick={() => {
              this.props.onClose();
            }}
          >
            ANULUJ
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (projectId, pageSize, pageNumber, filters = [], sorting = {}) =>
      dispatch(
        getPublicOrdersData(projectId, pageSize, pageNumber, filters, sorting)
      )
  };
};

export const PublicOrdersProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicOrders);
